import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { HelmetProvider } from 'react-helmet-async';

// Components
import GlassNavbar from './components/GlassNavbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';


// Pages
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import DiagnosticsPage from './pages/DiagnosticsPage';
import SurgeriesPage from './pages/SurgeriesPage';
import BranchesPage from './pages/BranchesPage';
import BlogPage from './pages/BlogPage';
import XRayPage from './pages/XRayPage';
import CriticalCarePage from './pages/CriticalCarePage';
import GroomingPage from './pages/GroomingPage';
import PreventiveCarePage from './pages/PreventiveCarePage';
import VaccinationPage from './pages/VaccinationPage';
import MonitoringPage from './pages/MonitoringPage';
import SterilizationPage from './pages/SterilizationPage';
import InternalMedicinePage from './pages/InternalMedicinePage';
import DiagnosticServicesPage from './pages/DiagnosticServicesPage';
import ExpertPetCarePage from './pages/ExpertPetCarePage';
import EssentialsNutritionPage from './pages/EssentialsNutritionPage';
import BoardingPage from './pages/BoardingPage';
import CardiologyPage from './pages/CardiologyPage';
import OphthalmologyPage from './pages/OphthalmologyPage';
import DentistryPage from './pages/DentistryPage';
import ExoticCarePage from './pages/ExoticCarePage';
import PhysiotherapyPage from './pages/PhysiotherapyPage';
import OncologyPage from './pages/OncologyPage';
import OrthopaedicsPage from './pages/OrthopaedicsPage';
import DermatologyPage from './pages/DermatologyPage';
import GynecologyPage from './pages/GynecologyPage';
import TravelDocsPage from './pages/TravelDocsPage';
import NGODiscountPage from './pages/NGODiscountPage';
import PharmacyPage from './pages/PharmacyPage';
import ConsultationPage from './pages/ConsultationPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';

gsap.registerPlugin(ScrollTrigger);

function App() {

  React.useLayoutEffect(() => {
    const lenis = new Lenis({
      lerp: 0.1,
      duration: 1.2,
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    const resizeObserver = new ResizeObserver(() => {
      ScrollTrigger.refresh();
    });
    
    resizeObserver.observe(document.body);

    return () => {
      lenis.destroy();
      gsap.ticker.remove(lenis.raf);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="bg-background text-foreground min-h-screen overflow-x-hidden">
        <ScrollToTop />
        <GlassNavbar />
        
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/diagnostics" element={<DiagnosticsPage />} />
            <Route path="/surgeries" element={<SurgeriesPage />} />
            <Route path="/branches" element={<BranchesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/xray" element={<XRayPage />} />
            <Route path="/critical-care" element={<CriticalCarePage />} />
            <Route path="/grooming" element={<GroomingPage />} />
            <Route path="/preventive-care" element={<PreventiveCarePage />} />
            <Route path="/vaccination" element={<VaccinationPage />} />
            <Route path="/monitoring" element={<MonitoringPage />} />
            <Route path="/sterilization" element={<SterilizationPage />} />
            <Route path="/internal-medicine" element={<InternalMedicinePage />} />
            <Route path="/diagnostic-services" element={<DiagnosticServicesPage />} />
            <Route path="/expert-pet-care" element={<ExpertPetCarePage />} />
            <Route path="/essentials-nutrition" element={<EssentialsNutritionPage />} />
            <Route path="/boarding" element={<BoardingPage />} />
            <Route path="/cardiology" element={<CardiologyPage />} />
            <Route path="/ophthalmology" element={<OphthalmologyPage />} />
            <Route path="/dentistry" element={<DentistryPage />} />
            <Route path="/exotic-care" element={<ExoticCarePage />} />
            <Route path="/physiotherapy" element={<PhysiotherapyPage />} />
            <Route path="/oncology" element={<OncologyPage />} />
            <Route path="/orthopaedics" element={<OrthopaedicsPage />} />
            <Route path="/dermatology" element={<DermatologyPage />} />
            <Route path="/gynecology" element={<GynecologyPage />} />
            <Route path="/travel-docs" element={<TravelDocsPage />} />
            <Route path="/ngo-discount" element={<NGODiscountPage />} />
            <Route path="/pharmacy" element={<PharmacyPage />} />
            <Route path="/consultation" element={<ConsultationPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-conditions" element={<TermsConditionsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </AnimatePresence>

        <WhatsAppButton />
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
